export default __webpack_public_path__ + "static/media/coin_empty.81c8fa92.svg";